<template>
  <div class="pg-breadcrumb">
    <div class="pg-breadcrumb-left">
      <div class="pg-crumb">
        Home /
        <span
          v-for="(breadcrumb, idx) in getBreadCrumbs"
          :key="idx"
          class="pg-title custom-breadcrumb"
          @click="redirectTo(breadcrumb.url)"
        >
          <span :class="idx == 0 && getBreadCrumbs.length >1?'crumb-link':''">{{ breadcrumb.title }} </span
          ><template v-if="getBreadCrumbs.length != idx + 1">/</template>
        </span>
      </div>
    </div>
    <div class="pg-breadcrumb-right">
      <div class="user-detail">
        <span class="pg-time">Welcome, </span>
        <strong>
          {{ partyName }}
        </strong>
        <span class="px-2"> |</span>
      </div>
      <div class="pg-time">{{ currentTimeDate }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Breadcrumb",
  data() {
    return {
      currentTimeDate: "",
      partyName: "",
    };
  },
  computed: {
    ...mapGetters(["getPageData", "getUserInfo"]),
    getBreadCrumbs() {
      const { breadcrumbs } = this.getPageData;
      return breadcrumbs.slice().reverse();
    },
  },
  mounted() {
    this.getCurrentTimeDate();
    this.partyName = this.getUserInfo.partyName
      ? this.getUserInfo.partyName
      : localStorage.getItem("partyName");
  },
  methods: {
    redirectTo(url) {
      this.$router.push(url).catch(() => {});
    },
    getCurrentTimeDate() {
      const d = new Date();
      const nth = (d) => {
        if (d > 3 && d < 21) return "th";
        switch (d % 10) {
          case 1:
            return "st";
          case 2:
            return "nd";
          case 3:
            return "rd";
          default:
            return "th";
        }
      };
      const monthList = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "July",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      const date =
        day + nth(day) + " " + monthList[d.getMonth()] + " " + d.getFullYear();
      const time = d.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
      this.currentTimeDate = `${date} at ${time}`;
    },
  },
};
</script>
<style scoped>
.crumb-link {
  text-decoration: underline;
  color: var(--ur__color--primary);
  cursor: pointer;
}
</style>
